import { createContext, useContext } from 'react';

/**
 * PD-16033 — where the user was when they opened Settings.
 *
 * Settings renders as a blocking layer over the page the user came from
 * (the app keeps that page mounted underneath by rendering the main route
 * tree against the remembered location). Closing the layer navigates back to
 * this path. A deep link straight into Settings has no origin, so the layer
 * opens over the dashboard and Close returns there.
 */
export interface SettingsOriginModel {
	/** pathname + search + hash of the page underneath, or null for a deep link. */
	originPath: string | null;
}

export const SettingsOriginContext = createContext<SettingsOriginModel>({
	originPath: null,
});

export const SETTINGS_ORIGIN_FALLBACK_PATH = '/dashboard';

export function useSettingsOrigin(): SettingsOriginModel & {
	closePath: string;
} {
	const value = useContext(SettingsOriginContext);
	return {
		...value,
		closePath: value.originPath ?? SETTINGS_ORIGIN_FALLBACK_PATH,
	};
}

export function isSettingsPath(pathname: string): boolean {
	return pathname === '/settings' || pathname.startsWith('/settings/');
}
